export interface FormTocViewState {
    expandedIds: Set<string>;
    searchText: string;
}

export enum FormTocViewActionType {
    Initialize = 'Initialize',
    ExpandAll = 'ExpandAll',
    ExpandNodes = 'ExpandNodes',
    CollapseAll = 'CollapseAll',
    ToggleNode = 'ToggleNode',
    SearchChanged = 'SearchChanged',
}

export type FormTocViewAction =
    | {
          type: FormTocViewActionType.Initialize;
          expandedIds: Set<string>;
          preserveExpanded: boolean;
      }
    | {
          type: FormTocViewActionType.ExpandAll;
          allNodeIds: string[];
      }
    | {
          type: FormTocViewActionType.ExpandNodes;
          nodeIds: string[];
      }
    | {
          type: FormTocViewActionType.CollapseAll;
      }
    | {
          type: FormTocViewActionType.ToggleNode;
          nodeId: string;
          isExpanded: boolean;
      }
    | {
          type: FormTocViewActionType.SearchChanged;
          searchText: string;
          allNodeIds: string[];
          shouldExpandAll: boolean;
      };

export const initialFormTocViewState: FormTocViewState = {
    expandedIds: new Set<string>(),
    searchText: '',
};

export function formTocViewReducer(state: FormTocViewState, action: FormTocViewAction): FormTocViewState {
    switch (action.type) {
        case FormTocViewActionType.Initialize: {
            const expandedIds: Set<string> = action.preserveExpanded ? new Set(state.expandedIds) : new Set(action.expandedIds);

            return {
                ...state,
                expandedIds,
            };
        }
        case FormTocViewActionType.ExpandAll: {
            const expandedIds: Set<string> = new Set(action.allNodeIds);

            return {
                ...state,
                expandedIds,
            };
        }
        case FormTocViewActionType.ExpandNodes: {
            const expandedIds: Set<string> = new Set(state.expandedIds);

            for (const nodeId of action.nodeIds) {
                expandedIds.add(nodeId);
            }

            return {
                ...state,
                expandedIds,
            };
        }
        case FormTocViewActionType.CollapseAll:
            return {
                ...state,
                expandedIds: new Set<string>(),
            };
        case FormTocViewActionType.ToggleNode: {
            const expandedIds: Set<string> = new Set(state.expandedIds);

            if (action.isExpanded) {
                expandedIds.add(action.nodeId);
            } else {
                expandedIds.delete(action.nodeId);
            }

            return {
                ...state,
                expandedIds,
            };
        }
        case FormTocViewActionType.SearchChanged: {
            const expandedIds: Set<string> = action.shouldExpandAll ? new Set(action.allNodeIds) : new Set(state.expandedIds);

            return {
                ...state,
                expandedIds,
                searchText: action.searchText,
            };
        }
        default:
            return state;
    }
}
